import styled from 'styled-components';
import {
  Image,
  Container as SemanticContainer,
  Menu as SemanticMenu,
} from 'semantic-ui-react';
import { colors } from '@playbookux/playbook-web-core';
import Dropdown from '../../layout-components/dropdown';

const { WHITE } = colors;

const Link = styled.div`
  visibility: ${(props) => props.showLogo};
  cursor: pointer;
`;

const Grow = styled.div`
  display: flex;
  flex-grow: 1;
  margin: auto;
  padding-left: 5px;
  align-items: center;
  justify-content: flex-start;
`;

const Logo = styled(Image)`
  &&& {
    display: inline;
    max-width: 150px;
  }
`;

const Container = styled(SemanticContainer)`
  &&&& {
    display: flex;
    width: 100%;
    margin-left: 20px !important;
  }
`;

const Menu = styled(SemanticMenu)`
  height: 55px;
  &&&& {
    box-shadow: none;
    background-color: ${(props) => props.theme.color.white};
    border-bottom: 1px solid rgba(34,36,38,.15);
    z-index: 999;
    &.ui.secondary.pointing.menu .item {
      align-self: center;
    }
  }
`;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 55px;
  justify-content: center;
  margin-bottom: 45px;
`;

const MenuItem = styled(SemanticMenu.Item)`
  &&&& {
    font-family: roboto;
    &.item {
      font-size: 15px;
      font-weight: 500;
      border-bottom: 0;
    }
    &.active.item{
      color: ${(props) => props.theme.color.primary};
      font-size: 15px;
      font-weight: 500;
      border-bottom: 0;
    }
    &.active.item:hover{
      color: ${(props) => props.theme.color.primary};
      border-bottom: 0;
    }
  }
`;

const CustomDropdown = styled(Dropdown)`
  &&& {
    &.active {
      background: ${WHITE};
      border-bottom: 1px;
    }

    &.dropdown.item .menu .item {
      color: #4D5473 !important;
      border-bottom: 1px;
      margin: 0 0 -1px;
    }

    &.dropdown.item .menu .active  {
      background: ${WHITE} !important;
      color: #477AE9 !important;
    }

    &.dropdown.item .menu {
      margin-top: 5px;
      border-radius: 5px;
      font-size: 14px;
    }

    &.ui.dropdown>.dropdown.icon {
      display: none;
    }
  }
    &&&&&&& {
      padding: 10px;
    }
`;

export {
  Link,
  Grow,
  LogoContainer,
  Logo,
  CustomDropdown,
  Container,
  Menu,
  MenuItem,
};
